import { TOGGLE_THEME, SET_THEME } from './actions';

const initialState = {
    isDarkMode: localStorage.getItem('theme') === 'dark' ||
        (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches),
};

const themeReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_THEME:
            const newTheme = !state.isDarkMode;
            localStorage.setItem('theme', newTheme ? 'dark' : 'light');
            return {
                ...state,
                isDarkMode: newTheme,
            };
        case SET_THEME:
            const isDark = action.payload === 'dark';
            localStorage.setItem('theme', isDark ? 'dark' : 'light');
            return {
                ...state,
                isDarkMode: isDark,
            };
        default:
            return state;
    }
};

export default themeReducer;
